import clsx from "clsx";
import styles from "./travellingToTag.module.scss";
import ArrowRightFilledIcon from "@medoma/components/icons/ArrowRightFilledIcon";
import { Tag } from "@medoma/components/Tag/Tag";
import { useLingui } from "@lingui/react/macro";
import { visitStatusSchema } from "@medoma/models/activities";
import { visitStatusDictionary } from "@medoma/models/visits";

const statusToColorMap: Record<
  typeof visitStatusSchema.enum.travellingTo,
  "blue"
> = {
  travellingTo: "blue",
};

const Icon = ({
  status,
}: {
  status: typeof visitStatusSchema.enum.travellingTo;
}) => (
  <div className={styles.iconWrapper}>
    <div className={clsx(styles.icon, styles[`icon-${status}`])}>
      <ArrowRightFilledIcon />
    </div>
  </div>
);

export const TravellingToTag = () => {
  const status = visitStatusSchema.enum.travellingTo;
  const { t } = useLingui();
  const label = t(visitStatusDictionary[status]);

  return (
    <Tag
      icon={<Icon status={status} />}
      color={statusToColorMap[status]}
      label={label}
      size="small"
      variant="icon-and-text"
    />
  );
};
